module.exports = __webpack_public_path__ + "static/zopsmart-final-logo-b20801f896333a39e9cb517067416859.svg";